import { Box, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { CustomHeading } from 'shared-components';
import { ApplicationState } from '../../../../../store';
import Field from '../../../../Field/Field';
import { PrevNextButtons } from '../../../../PrevNextButtons';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { getApplicationData } from '@/components/pages/applicant-dashboard/sections/helpers/getApplicationData';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';
import { useTranslation } from "react-i18next";

export default function InformationProcessing() {
    const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { application } = useSelector((state: ApplicationState) => state.apply);
  const { applyConfig } = useSelector((state: ApplicationState) => state.applyConfig);
  const { nextRoute, previousRoute } = useTaskNavigation();

  const { initial, current } = getApplicationData(application);
  const { informationProcessingConsent } = current;
  const { informationProcessingConsent: initialInformationProcessingConsent } = initial;

  const AcceptanceText = () => (
    <>
      <Text>
        {t('common:iUnderstandThatTheApplicationPro')}
                    </Text>
      <Text>
        {t('common:thisDataWillBeProcessedByTheUniv')}
                    </Text>
    </>
  );

  const RejectionText = () => <Text>{t('common:thisUserHasNotAcceptedTheirInfor')}</Text>;

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <CustomHeading level="h1" flexGrow={1} mb={8}>
          {t('common:informationProcessing')}
                          </CustomHeading>

        <CustomHeading level="h2" mb={2} mt={6} fontSize="md">
          {t('common:data')}
                          </CustomHeading>

        <Box>
          {(informationProcessingConsent || initialInformationProcessingConsent) && (
            <Field
              leftLabel="Agreed to"
              value={informationProcessingConsent ? <AcceptanceText /> : <RejectionText />}
              originalValue={initialInformationProcessingConsent ? <AcceptanceText /> : <RejectionText />}
            />
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={() => {
              // Use dynamic navigation, but fallback to legacy logic if needed
              if (previousRoute) {
                navigate(previousRoute);
              } else {
                // Fallback to legacy logic for declarations task
                const previousSection = applyConfig?.disableDeclarationTask ? '../referral' : '../declarations';
                navigate(previousSection);
              }
            }}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
